import React from "react";
import { buildPlanEntitlements, draftToPreviewPlan } from "./planUtils";
import SubscriptionPlanCard from "./subscriptionPlanCard";

const ProductPlanPreview = ({ draftProduct, tenantCurrency }) => {
  const plan = draftToPreviewPlan(draftProduct, tenantCurrency);
  const entitlements = buildPlanEntitlements(plan);

  return (
    <div className="stripe-product-preview-card">
      <SubscriptionPlanCard
        name={plan.name}
        priceDisplay={plan.price_display}
        description={plan.description}
        features={plan.features}
        entitlements={entitlements}
        ctaLabel="Subscribe"
        ctaDisabled
        emptyMessage="Add features and allowances to preview"
      />
    </div>
  );
};

export default ProductPlanPreview;
